import api from "~/apis/api";
import { CONTAINER } from "~/apis/basePaths";

export const getLabels = query =>
  api.get({
    path: `${CONTAINER}/labels`,
    query,
  });
